export default __webpack_public_path__ + "feature2add590.png";